import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { getServerIdOnly } from "helpers/helper";
import ModalLokasi from "components/ModalLokasi";
import { getProducts } from "features/hosting/hostingSlice";
import { useDispatch } from "react-redux";

const wordpressServer = [
	{id: 706, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)'},
	{id: 707, serverName: 'SouthJKT-2 (MTEN - Tier III)'},
]

const bussinessServer = [
	{id: 695, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)'},
	{id: 699, serverName: 'SouthJKT-2 (MTEN - Tier III)'},
	{id: 702, serverName: 'WestJavaBDG-1 (BBU - Tier III)'},
	{id: 'sgp', serverName: 'SGP-1'},
]

const enterpriseServer = [
	{id: 696, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)'},
	{id: 700, serverName: 'SouthJKT-2 (MTEN - Tier III)'},
	{id: 703, serverName: 'WestJavaBDG-1 (BBU - Tier III)'},
]

const vpsServer = [
	{id: 688, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)'},
	{id: 697, serverName: 'SouthJKT-2 (MTEN - Tier III)'},
	{id: 701, serverName: 'WestJavaBDG-1 (BBU - Tier III)'},
	{id: 725, serverName: 'USA (Tier III)'}
]

const cloudPro = [
	{id: 710, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)'},
	{id: 713, serverName: 'SouthJKT-2 (MTEN - Tier III)'},
	{id: 715, serverName: 'WestJavaBDG-1 (BBU - Tier III)'},
	{id: 717, serverName: 'Singapura (Tier III)'},
]

const cloudWp = [
	{id: 711, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)'},
	{id: 714, serverName: 'SouthJKT-2 (MTEN - Tier III)'},
	{id: 716, serverName: 'WestJavaBDG-1 (BBU - Tier III)'},
	{id: 718, serverName: 'Singapura (Tier III)'},
]

const ServerOptions = ({
  server,
  setServer,
  currentProdName,
  setCurrentName,
  onServerChange,
  activePid,
}) => {
  // console.log("server", server);
  // console.log("setServer", setServer);
  // console.log("currentProdName", currentProdName);
  // console.log("setCurrentName", setCurrentName);

  const dispatch = useDispatch();
  const [serverSelected, setServerSelected] = useState({
    serverId: null,
    serverData: null,
    serverList: null,
  });
  const [checked, setChecked] = useState(null);
  const [modalLokasi, setModalLokasi] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    if (server && checked !== server) {
      setChecked(server);
    }
  }, [server, checked]);

  useEffect(() => {
    if (server) {
      switch (server) {
        case 706:
        case 707:
          setServerSelected({
            serverId: server,
            serverData: wordpressServer,
            serverList: getServerIdOnly(wordpressServer),
          });
          break;
        case 695:
        case 699:
        case 702:
          setServerSelected({
            serverId: server,
            serverData: bussinessServer,
            serverList: getServerIdOnly(bussinessServer),
          });
          break;
        case 696:
        case 700:
        case 703:
          setServerSelected({
            serverId: server,
            serverData: enterpriseServer,
            serverList: getServerIdOnly(enterpriseServer),
          });
          break;
        case 688:
        case 697:
        case 701:
          setServerSelected({
            serverId: server,
            serverData: vpsServer,
            serverList: getServerIdOnly(vpsServer),
          });
          break;
        case 710:
        case 713:
        case 715:
        case 717:
          setServerSelected({
            serverId: server,
            serverData: cloudPro,
            serverList: getServerIdOnly(cloudPro),
          });
          break;
        case 711:
        case 714:
        case 716:
        case 718:
          setServerSelected({
            serverId: server,
            serverData: cloudWp,
            serverList: getServerIdOnly(cloudWp),
          });
          break;
        default:
          break;
      }
    }
  }, [server]);

  const serverChangeHandler = (e) => {
    const selectedServerId = e.target.value;
    
    setChecked(selectedServerId);
    setIsButtonDisabled(true);

    if (selectedServerId === "sgp") {
      setServerSelected({
        ...serverSelected,
        serverId: selectedServerId,
      });
      setServer(+695);
      setCurrentName("sgp");
    } else {
      const newServerId = +parseInt(selectedServerId);
      setServerSelected({
        ...serverSelected,
        serverId: newServerId,
      });
      setServer(newServerId);
      setCurrentName("");
      
      // Gunakan onServerChange jika tersedia (dari Hosting component), jika tidak gunakan dispatch langsung
      if (onServerChange) {
        onServerChange(newServerId);
      } else {
        dispatch(getProducts({ gid: newServerId, activePid }));
      }
    }

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 3000);
  };

  const ServerOptionsRadio = ({ serverItems }) => {
    const allowedIndices = [];
    if (currentProdName) {
      if (
        currentProdName.includes("HPCH Bisnis 1") ||
        currentProdName.includes("HPCH Bisnis 2")
      ) {
        allowedIndices.push(0, 1, 3);
      } else if (
        currentProdName.includes("HPCH Bisnis 3") ||
        currentProdName.includes("HPCH Bisnis 4") ||
        currentProdName.includes("HPCH Bisnis 5") ||
        currentProdName.includes("HPCH Bisnis 6") ||
        currentProdName.includes("HPCH Bisnis 7") ||
        currentProdName.includes("HPCH Bisnis 8")
      ) {
        allowedIndices.push(0, 2, 3);
      } else {
        serverItems.forEach((_, index) => allowedIndices.push(index));
      }

      const filteredItems = serverItems.filter((_, index) =>
        allowedIndices.includes(index)
      );

      return filteredItems.map((server) => (
        <Col xs={12} key={server.id} className="mb-3">
          <div className="form-check">
            <input
              type="radio"
              name="server"
              className="form-check-input me-3"
              id={`server${server.id}`}
              value={server.id}
              checked={parseInt(checked) === server.id || checked === server.id}
              onChange={serverChangeHandler}
              disabled={isButtonDisabled}
            />
            <label htmlFor={`server${server.id}`} className="form-check-label">
              {server.serverName.split('(')[0]}
              {server.serverName.includes('(') && (
                <span className="text-muted" style={{ fontSize: 'smaller', marginLeft: '8px' }}>
                  ({server.serverName.split('(')[1]}
                </span>
              )}
            </label>
          </div>
        </Col>
      ));
    }
  };

  const handlerCloseModal = () => {
    setModalLokasi(false);
  };

  return (
    <>
      {serverSelected.serverId && (
        <>
          <Card className="rounded-4 border-0 shadow-sm mb-4">
            <Card.Body>
              <Row>
                <Col xs={6} className="mb-2 mt-2">
                  <h5 className="fw-bold">Lokasi Server</h5>
                </Col>
                <Col xs={6}>
                  <div className="d-flex">
                    <button
                      onClick={() => setModalLokasi(true)}
                      className="h6 mb-0 text-qw-primary text-decoration-none fw-bold ms-auto border-0 bg-transparent"
                      style={{ cursor: "pointer" }}
                      disabled={isButtonDisabled}
                    >
                      Detail Lokasi Server
                    </button>
                  </div>
                </Col>
                <div className="px-4">
                  <label className="mb-3 small fw-semibold">
                    Pilih lokasi server sesuai dengan kebutuhan anda
                  </label>
                  <ServerOptionsRadio serverItems={serverSelected.serverData} />
                </div>
              </Row>
            </Card.Body>
          </Card>

          <ModalLokasi show={modalLokasi} onHide={handlerCloseModal} />
        </>
      )}
    </>
  );
};

export default ServerOptions;
